var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FD8F8F",
    strokeWidth: 1.071
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.333 3.853h12.745M2.245 3.853v9.559h8.922v-9.56M5.274 6.721v3.823M8.141 6.721v3.823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.157 3.853V.667h5.098v3.186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxDeleteIcon);
export default __webpack_public_path__ + "static/media/cx-delete-icon.89cad9d3f8125989602190c0ffc9c9dd.svg";
export { ForwardRef as ReactComponent };